import { render } from "./DispatcherCreateModal.vue?vue&type=template&id=f3643366&scoped=true"
import script from "./DispatcherCreateModal.vue?vue&type=script&lang=js"
export * from "./DispatcherCreateModal.vue?vue&type=script&lang=js"

import "./DispatcherCreateModal.vue?vue&type=style&index=0&id=f3643366&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3643366"]])

export default __exports__